/**
 * Created by Carsten Hibbeler on 11.02.2016.
 */
/**
 * modded version of https://github.com/perliedman/leaflet-realtime/blob/master/src/L.Realtime.js
 * Copyright (c) 2014, Per Liedman (per@liedman.net)
 * Permission to use, copy, modify, and/or distribute this software for any purpose with or without fee is hereby granted, provided that the above copyright notice and this permission notice appear in all copies.
 */

import L from 'external/leaflet';
import { textLabelIcon } from '../plugins/DrawerPlugin/TextLabelIcon';
import { boIcon } from '../utils/icons';

const DrawerGeoJsonLayer = L.GeoJSON.extend({

    addData(geojson) {
        let features = L.Util.isArray(geojson) ? geojson : geojson.features,
            i, len, feature;

        if (features) {
            for (i = 0, len = features.length ; i < len ; i++) {
                // only add this if geometry or geometries are set and not null
                feature = features[i];
                if (feature.geometries || feature.geometry || feature.features || feature.coordinates) {
                    this.addData(feature);
                }
            }
            return this;
        }

        let options = this.options;

        if (options.filter && !options.filter(geojson)) {
            return this;
        }

        let layer = this.geometryToLayer(geojson, options);
        if (!layer) {
            return this;
        }
        //FIXME
        //layer.feature = L.GeoJSON.asFeature(geojson);

        layer.defaultOptions = layer.options;
        this.resetStyle(layer);

        if (options.onEachFeature) {
            options.onEachFeature(geojson, layer);
        }

        return this.addLayer(layer);
    },

    geometryToLayer(geojson, options) {
        const { properties, style } = geojson,
            geometry = geojson.type === 'Feature' ? geojson.geometry : geojson,
            coords = geometry ? geometry.coordinates : null,
            coordsToLatLng = options && options.coordsToLatLng || L.GeoJSON.coordsToLatLng;

        if (geometry.type === 'Point') {
            if (properties && properties.title && properties.icon) {
                let latlng = coordsToLatLng(coords);
                let textLabelMarker = L.marker(latlng, {
                    icon: textLabelIcon({
                        ...(properties.editFormData || {}),
                        ...style
                    }),
                    id: properties.id,
                    title: properties.title,
                    editFormData: properties.editFormData,
                    ...style,
                });

                textLabelMarker.drawerType = 'TextLabel';
                return textLabelMarker;
            } else if (properties && properties.radius) {
                return new L.Circle(coordsToLatLng(coords), {
                    ...properties,
                    ...style,
                });

            } else if (properties && properties.icon) {
                let latlng = coordsToLatLng(coords);
                const icon = properties.icon.html ? L.divIcon({ ...properties.icon }) : L.icon({ ...properties.icon });
                let iconLabelMarker = L.marker(latlng, {
                    icon,
                    id: properties.id
                });
                iconLabelMarker.drawerType = 'IconLabel';
                return iconLabelMarker;
            } else if (properties && !properties.icon && properties.type) {
                //  PlannedActions should use a className based icon
                let latlng = coordsToLatLng(coords);
                const icon = boIcon(properties.type);
                let iconMarker = L.marker(latlng, {
                    icon,
                    id: properties.id
                });
                iconMarker.drawerType = 'IconMarker';
                return iconMarker;
            }

        } else {
            const layer = L.GeoJSON.geometryToLayer(geojson, { ...options, ...geojson.style });

            if (!(layer instanceof L.Path)) {
                throw new Error('Unexpected layer type ' + layer);
            }

            return layer;
        }
    },

    getBounds() {
        const bounds = new L.LatLngBounds();

        for (let id in this._layers) {
            const layer = this._layers[id];
            if (layer.getBounds) {
                try {
                    bounds.extend(layer.getBounds());
                } catch (e) {
                    /**
                     * bounds of circle layer can't be calculated if layer is not on map
                     * https://github.com/Leaflet/Leaflet/issues/4978
                     */
                    console.warn('Fail to get bounds for layer', layer, 'Using layer center instead');
                    bounds.extend(layer.getLatLng());
                }
            } else {
                bounds.extend(layer.getLatLng());
            }
        }
        return bounds;
    }

});

export default DrawerGeoJsonLayer;



// WEBPACK FOOTER //
// ./js/layer/DrawerGeoJsonLayer.js